import './App.css'
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import MainPage from './pages/MainPage'
import ContactsPage from './pages/ContactsPage'
import GamesPage from './pages/GamesPage'
import BlogPage from './pages/BlogPage'
import BlogPostPage from './pages/BlogPostPage'
import Layout from './components/Layout'
import StorePage from './pages/StorePage'

function App() {
    return (
        <div className='App'>
            <BrowserRouter>
                <Routes>
                    <Route path='/' element={<Layout/>}>
                        <Route index element={<MainPage/>}/>
                        <Route path='contacts' element={<ContactsPage/>}/>
                        <Route path='games' element={<GamesPage/>}/>
                        <Route path='blog' element={<BlogPage />} />
                        <Route path='blog/:slug' element={<BlogPostPage />} />
                        <Route path='store' element={<StorePage />} /> 
                        <Route path='*' element={<div>404 - Page Not Found</div>}/>
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    )
}

export default App
